export default {
  data: function () {
    return {
      screenHeight: 720,
      screenWidth: 1280,
    }
  },
  beforeCreate: function () {
    if (process.client) {
      this.screenHeight = window.outerHeight
      this.screenWidth = window.outerWidth
    }
  },
  mounted: function () {
    this.getScreenHeight()
    this.getScreenWidth()
    this.$nextTick(() => {
      window.addEventListener("resize", this.getScreenWidth)
      window.addEventListener("resize", this.getScreenHeight)
    })
  },
  methods: {
    computeAllResize: function () {
      this.getScreenWidth()
      this.getScreenHeight()
    },
    getScreenWidth: function () {
      this.$set(this, "screenWidth", window.outerWidth)
    },
    getScreenHeight: function () {
      this.$set(this, "screenHeight", window.outerHeight)
    },
  },
}
